import {
    createOrGetIntersectionContext,
    useIntersectionTarget,
    UseIntersectionTargetCallback,
    UseIntersectionTargetOptions,
} from 'rwl-ui';

export const WIDGET_CONTAINER_INTERSECTION_OBSERVER_NAME =
    'widget-container-intersection-observer';

// Create the context and Provider once, and export them for use in other components
export const { Provider: WidgetContainerIntersectionProvider } =
    createOrGetIntersectionContext(WIDGET_CONTAINER_INTERSECTION_OBSERVER_NAME);

export const useWidgetContainerIntersection = (
    onIntersection: UseIntersectionTargetCallback,
    onIntersectionEnd: UseIntersectionTargetCallback,
    options: UseIntersectionTargetOptions
) => {
    return useIntersectionTarget(
        WIDGET_CONTAINER_INTERSECTION_OBSERVER_NAME,
        onIntersection,
        onIntersectionEnd,
        options
    );
};
